import NavBar from "./reusable-components/nav-bar";
import Rectangle from '../images/Rectangle.png';
import Footer from "./reusable-components/footer";
import HowToUsePageImage from '../images/howToUsePage.png';
import IQOSImage from '../images/IQOS-Image.png';
import OvalStep1 from '../images/OvalStep1.png';
import Step1Image from '../images/Step1Image.png';
import OvalStep2 from '../images/OvalStep2.png';
import Step2Image from '../images/Step2Image.png';
import OvalStep3 from '../images/OvalStep3.png';
import Step3Image from '../images/Step3Image.png';
import OvalStep4 from '../images/OvalStep4.png';
import Step4Image from '../images/Step4Image.png';
import OvalStep5 from '../images/OvalStep5.png';
import Step5Image from '../images/Step5Image.png';
import OvalStep6 from '../images/OvalStep6.png';
import Step6Image from '../images/Step6Image.png';

function HowToUsePage() {
    return (
        <div>
            <NavBar />
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div>
                <img src={HowToUsePageImage} style={{ width: '100%', height: '200px' }} alt="" />
            </div>
            <div>
                <div style={{
                    fontFamily: 'Sintony',
                    textAlign: 'center',
                    marginTop: '20px',
                    marginLeft: '20px',
                    marginRight: '20px'
                }}>
                    <span style={{
                        color: '#475666',
                        fontSize: '13px',
                        fontWeight: '700',
                    }}
                    >ABOUT IQOS</span>
                    <p style={{
                        fontSize: '13px',
                        marginTop: '20px',
                        color: '#475666',
                        lineHeight: '20px',
                        fontWeight: '400'
                    }}>
                        IQOS is a cigarette alternative that heats, but does
                        not burn tobacco. The resulting vapor releases
                        the true taste of heated tobacco.
                    </p>
                </div>
                <div>
                    <img src={IQOSImage} style={{ width: '100%', height: '592px' }} alt="" />
                </div>
                <div style={{
                    fontFamily: 'Sintony',
                    textAlign: 'center',
                    marginTop: '20px',
                    marginLeft: '20px',
                    marginRight: '20px',
                    marginBottom: '20px'
                }}>
                    <span style={{
                        color: '#475666',
                        fontSize: '13px',
                        fontWeight: '700',
                    }}
                    >SIX EASY STEPS TO USE</span>
                    <p style={{
                        fontFamily: 'Sintony',
                        color: '#475666',
                        fontSize: '13px',
                        marginTop: '20px',
                        lineHeight: '20px',
                        fontWeight: '400'
                    }}>
                        Lorem ipsum doler sit amnet lorem ipsum doler sit amnet. Lorem ipsum doler sit amn lorem sit ipsum.
                    </p>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px'
                        }}>
                            <img src={OvalStep1} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP ONE
                        </div>
                        <img src={Step1Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400',
                            marginBottom: '20px',
                        }}>Remove your charged iQOS Holder from the IQOS Pocket Charger.</div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px'
                        }}>
                            <img src={OvalStep2} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP TWO
                        </div>
                        <img src={Step2Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400'
                        }}>Insert a HeatStick into your IQOS Holder, tobacco
                            side down.</div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px',
                            marginTop: '20px'
                        }}>
                            <img src={OvalStep3} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP THREE
                        </div>
                        <img src={Step3Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400'
                        }}>Press and hold the 'On' button for two seconds. The green LED will blink.</div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px',
                            marginTop: '20px'
                        }}>
                            <img src={OvalStep4} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP FOUR
                        </div>
                        <img src={Step4Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400'
                        }}>When the IQOS LED remains solid green, you can enjoy your HeatStick for up to approximately 6 minutes or 14 puffs.</div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px',
                            marginTop: '20px'
                        }}>
                            <img src={OvalStep5} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP FIVE
                        </div>
                        <img src={Step5Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400'
                        }}>When the LED turns off, the experience is finished. Pull up the cap until it stops and pull out the used HeatStick from the cap.</div>
                    </div>
                    <div>
                        <div style={{
                            fontFamily: 'Sintony',
                            fontSize: '15px',
                            fontWeight: '700',
                            color: '#3786C3',
                            marginBottom: '20px',
                            lineHeight: '19.54px',
                            marginTop: '20px'
                        }}>
                            <img src={OvalStep6} style={{ width: '28px', height: '28px', marginRight: '5px' }} alt="" />  STEP SIX
                        </div>
                        <img src={Step6Image} style={{ width: '100%' }} alt='' />
                        <div style={{
                            fontFamily: 'Sintony',
                            color: '#475666',
                            fontSize: '13px',
                            marginTop: '20px',
                            lineHeight: '20px',
                            fontWeight: '400'
                        }}>Place the holder in the charger until the next use.</div>
                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
}

export default HowToUsePage;